import React, { Fragment, useState } from 'react';
import {
    alpha,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Popover,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core';
import { IButtonFilter } from './types';
import CloseIcon from '@material-ui/icons/Close';
import { ChevronDown } from 'react-feather';

const POPOVER_VIEWPORT_GAP = 8;

interface IPopoverPosition {
    top: number;
    left: number;
    width: number;
}

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        textTransform: 'capitalize',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 56,
        padding: 10,
        width: '100%',
        minWidth: 180,
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.05),
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            transition: '0.6s',
        },
    },
    text: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        fontWeight: 400,
        display: 'flex',
        flexGrow: 1,
        color: 'inherit',
    },
    divider: {
        marginRight: 10,
    },
    card: {
        boxSizing: 'border-box',
        width: '100%',
        overflow: 'auto',
    },
    icon: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        height: 20,
        width: 20,
    },
}));

export const ButtonFilter = ({
    currents,
    setCurrents,
    title,
    type,
    content,
    cardStyle = {},
    cardContentStyle = {},
    ...props
}: IButtonFilter) => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [popoverPosition, setPopoverPosition] =
        useState<IPopoverPosition | null>(null);

    const openPopover = (event: any) => {
        const anchor = event.currentTarget as HTMLElement;
        const anchorRect = anchor.getBoundingClientRect();

        setPopoverPosition({
            top: anchorRect.bottom,
            left: anchorRect.left,
            width: anchorRect.width,
        });
        setAnchorEl(anchor);
    };

    const closePopover = () => {
        setAnchorEl(null);
    };

    return (
        <Fragment>
            <Button
                variant="outlined"
                onClick={(event) =>
                    anchorEl ? closePopover() : openPopover(event)
                }
                className={classes.button}
                {...props}
            >
                <Box
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <Divider
                        orientation="vertical"
                        flexItem
                        className={classes.divider}
                    />
                    <span className={classes.text}>{title}</span>
                    {anchorEl ? (
                        <CloseIcon className={classes.icon} />
                    ) : (
                        <ChevronDown className={classes.icon} />
                    )}
                </Box>
            </Button>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorReference="none"
                onClose={() => closePopover()}
                PaperProps={{
                    style: {
                        top: popoverPosition?.top,
                        left: popoverPosition?.left,
                        width: popoverPosition?.width,
                        maxHeight: `calc(100vh - ${
                            (popoverPosition?.top || 0) + POPOVER_VIEWPORT_GAP
                        }px)`,
                    },
                }}
            >
                <Card className={classes.card} style={{ ...cardStyle }}>
                    <CardContent style={{ ...cardContentStyle }}>
                        {content}
                    </CardContent>
                </Card>
            </Popover>
        </Fragment>
    );
};
